module.exports = __webpack_public_path__ + "static/media/createThumbnail.3c17ed6d.png";